import React from 'react'
import ReactDOM from 'react-dom/client'
import { api, setClientInfo } from '@carrent/api'
import { startTelemetry } from '@carrent/core'
import { offline } from '@carrent/platform'
import App from './App.jsx'
import { startDriverQueue } from './offline/startQueue'

import '@carrent/ui/styles/tokens.css'
import '@carrent/ui/styles/base.css'
import './styles/driver.css'

// Достоверный X-Client-App для потоков логирования.
setClientInfo({ app: 'driver', version: __APP_VERSION__ })

// Сбор телеметрии. Уважает переключатель в настройках и никогда
// не влияет на работу приложения: ошибки внутри проглатываются.
startTelemetry(api)

// Очередь отправки. Регистрируется до рендера: задачи, оставшиеся
// с прошлого запуска (приложение закрыли, не дождавшись сети),
// должны уйти сразу, а не после того, как водитель откроет нужный
// экран. Сбой запуска очереди не должен ронять приложение —
// без неё оно работает как раньше, просто без офлайна.
startDriverQueue().catch((error) => {
  console.error('Очередь отправки не запустилась', error)
})

// Service worker: приложение должно открываться без сети.
// Регистрируем после загрузки, чтобы не соперничать за канал
// с первыми запросами.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Отсутствие офлайн-оболочки не повод ломать приложение.
    })
  })

  // Background Sync будит воркер, тот просит окно разгрузить очередь.
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'flush-outbox') offline.worker.flush()
    // Deep-link из нажатия на пуш: навигацию делает приложение —
    // у него роутер; sw только фокусирует окно и передаёт адрес.
    if (event.data?.type === 'open-chat' && event.data.url) {
      globalThis.location.assign(event.data.url)
    }
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
